import { Outlet } from 'react-router-dom';
import ComplianceNote from './ComplianceNote';
import Footer from './Footer';
import Navbar from './Navbar';

export default function Layout() {
  return (
    <div className="min-h-screen overflow-hidden bg-cloud text-ink transition-colors duration-300 dark:bg-[#07111f] dark:text-white">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <ComplianceNote />
      <Footer />
    </div>
  );
}
